import React, { ReactElement } from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';

const { globalIcon, primary } = colors;

const Container = styled.div<{ active: boolean }>`
  color: ${props => (props.active ? primary : globalIcon)};
  height: 24px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: ${props => (props.active ? primary : globalIcon)};
  z-index: 1;
  :hover {
    color: ${primary};
    cursor: pointer;

    svg > * {
      fill: ${primary};
    }
  }
`;

export interface IVisualToggleProps {
  active: boolean;
  icon: ReactElement;
  onClick: () => void;
}

export default ({ active, icon, onClick }: IVisualToggleProps) => {
  return (
    <Container active={active} onClick={onClick} data-testid="visual-toggle-button">
      {icon}
    </Container>
  );
};
